<template>

    <PublicWidgetsWrapper ref="wrapper">
      
      <div class="flex flex-row items-top justify-between">
        <h1 class="text-lg font-semibold mb-3">Bulk Search</h1>
      </div>

        <div style="background: rgba(58, 155, 219, 0.1); border-radius: 10px; padding: 10px; color: #3A9BDB; font-weight: bold; clear: both; margin-top: 15px; margin-bottom: 15px; font-size: 12px;">

<svg class="ml-2 mr-2" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_183_9856)">
<path d="M12.5901 22.3394C17.9669 22.3394 22.3409 17.9653 22.3409 12.5894C22.3409 7.21339 17.9669 2.83936 12.5901 2.83936C7.21339 2.83936 2.83936 7.2126 2.83936 12.5894C2.83936 17.9661 7.21339 22.3394 12.5901 22.3394ZM12.5901 4.41473C17.0981 4.41473 20.7656 8.08221 20.7656 12.5894C20.7656 17.0965 17.0981 20.764 12.5901 20.764C8.08221 20.764 4.41473 17.0973 4.41473 12.5894C4.41473 8.08142 8.08221 4.41473 12.5901 4.41473Z" fill="#3A9BDB"/>
<path d="M12.5899 10.6152C12.1543 10.6152 11.8022 10.9681 11.8022 11.4029V17.9329C11.8022 18.3677 12.1543 18.7205 12.5899 18.7205C13.0255 18.7205 13.3776 18.3677 13.3776 17.9329V11.4029C13.3776 10.9681 13.0255 10.6152 12.5899 10.6152Z" fill="#3A9BDB"/>
<path d="M12.591 9.50094C13.2136 9.50094 13.7182 8.99629 13.7182 8.37376C13.7182 7.75124 13.2136 7.24658 12.591 7.24658C11.9685 7.24658 11.4639 7.75124 11.4639 8.37376C11.4639 8.99629 11.9685 9.50094 12.591 9.50094Z" fill="#3A9BDB"/>
</g>
<defs>
<clipPath id="clip0_183_9856">
<rect width="26" height="26" fill="white"/>
</clipPath>
</defs>
</svg>


            The Bulk Search tool is only available on the Professional Plan. Below is a preview of how this tool works and can save you time. <a href="#">View Plans</a>
        </div>
  
      <hr class="border-b border-gray-100 mb-3">
  
        <div class="dashboard-box mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
                <h2 class="text-bold mb-2">Bulk Search 1 keyword in Multiple Cities</h2>

                <h3 class="text-xs mb-4">Enter 1 Keyword and Multiple Cities (up to 3)</h3>

                <div class="w-full mb-4">
                    <div class="flex flew-row flex-wrap">
                        <div class="w-full mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>Pick a Keyword</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="bulk_1_keyword" />
                        </div>
                        <div class="w-full mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Cities</strong></p>
                            
                            <v-combobox
                                label="Search for cities"
                                prepend-inner-icon="mdi-map-marker-outline"
                                append-icon=""
                                v-model="autocompleteLocationModel"
                                :items="locationFoundItems"
                                :search-input.sync="locationSearchText"
                                item-text="value"
                                item-value="id"
                                hide-no-data
                                return-object
                                outlined
                                dense
                                hide-details
                                @change="addCity()"
                                style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                            >
                            </v-combobox>

                            <div class="pt-3" v-for="(item, index) in selectedCities" :key="index">
                                <div style="display: inline-block;">
                                    {{ item.city }}, {{ item.state }}

                                    <a href="javascript: void(0);" @click="removeCity(index)"><i class="fa fa-times"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2 mb-2" @click="fetchLeads1();">
                        <i v-if="fetchingLeads1" class="fa fa-spin fa-spinner"></i>
                        <span v-else>FETCH LEADS</span>
                    </div>

                    <div v-if="add_search_error1" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert" style="clear: both;">
                        <div v-html="add_search_error1"></div>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>
        </v-card>
        </div>

        <div class="dashboard-box mb-5">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
                <h2 class="text-bold mb-2">Bulk Search 1 City For Multiple Keywords</h2>

                <h3 class="text-xs mb-4">Choose 1 City and search for many keywords (up to 3)</h3>

                <div class="w-full mb-4">
                    <div class="flex flew-row flex-wrap">
                        <div class="w-full mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Select a Location</strong></p>
                            
                            <v-combobox
                                label="Search for cities"
                                prepend-inner-icon="mdi-map-marker-outline"
                                append-icon=""
                                v-model="autocompleteLocationModel2"
                                :items="locationFoundItems"
                                :search-input.sync="locationSearchText2"
                                item-text="value"
                                item-value="id"
                                hide-no-data
                                return-object
                                outlined
                                dense
                                hide-details
                                @change="selectPlace()"
                                style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                            >
                            </v-combobox>
                        </div>
                        <div class="w-full mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Enter up to 3 Keywords</strong></p>
                            <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" placeholder="contractor, roofer, plumber" v-model="bulk_2_keywords" />
                        </div>
                    </div>

                    <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2 mb-2" @click="fetchLeads2();">
                        <i v-if="fetchingLeads2" class="fa fa-spin fa-spinner"></i>
                        <span v-else>FETCH LEADS</span>
                    </div>

                    <div v-if="add_search_error2" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert" style="clear: both;">
                        <div v-html="add_search_error2"></div>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>
        </v-card>
        </div>

        <div class="dashboard-box">
          <v-card
            class="pa-2"
            tile
          >
            <div class="p-3">
                <h2 class="text-bold mb-2">Bulk Search 1 keyword in Every zip code of city</h2>

                <h3 class="text-xs mb-4">Enter 1 Keyword and a City</h3>

                <div class="w-full mb-4">
                    <div class="flex flew-row flex-wrap">
                        <div class="w-full mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>Pick a Keyword</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="bulk_3_keyword" />
                        </div>
                        <div class="w-full mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Choose a City</strong></p>
                            
                            <v-combobox
                                label="Search for cities"
                                prepend-inner-icon="mdi-map-marker-outline"
                                append-icon=""
                                v-model="autocompleteLocationModel3"
                                :items="locationFoundItems"
                                :search-input.sync="locationSearchText3"
                                item-text="value"
                                item-value="id"
                                hide-no-data
                                return-object
                                outlined
                                dense
                                hide-details
                                @change="selectPlace3()"
                                style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                            >
                            </v-combobox>
                        </div>

                        <div v-if="search_location3" class="w-full mb-4">
                            <p class="mb-1 text-xs mb-2"><strong>Zip codes in {{ search_location3.city }}</strong></p>
                            
                            <div style="background: rgba(0, 0, 0, 0.03); border-radius: 5px; padding: 20px;">
                                <i v-if="searchingZipCodes" class="fa fa-spin fa-spinner"></i>

                                <div v-else style="max-height: 250px; overflow-y: auto;">
                                    <div v-for="(item, index) in zip_codes" :key="index" style="color: #000000; font-size: 12px;">
                                        {{ item.zip }} &nbsp;&nbsp;
                                        <span style="color: rgba(0, 0, 0, 0.6);">{{ item.county }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2 mb-2" @click="fetchLeads3();">
                        <i v-if="fetchingLeads3" class="fa fa-spin fa-spinner"></i>
                        <span v-else>FETCH LEADS</span>
                    </div>

                    <div v-if="add_search_error3" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert" style="clear: both;">
                        <div v-html="add_search_error3"></div>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>
        </v-card>
        </div>
  
    </PublicWidgetsWrapper>
  
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import $ from 'jquery'
  import moment from 'moment'
  import { GetSuggestions } from '@/utils/PlaceUtils'
  import PublicWidgetsWrapper from '@/views/panel/PublicWidgets/Wrapper.vue'

  export default {
    components: {
        PublicWidgetsWrapper
    },
    data () {
      return {
        bulk_1_keyword: "",
        bulk_2_keywords: "",
        bulk_3_keyword: "",

        autocompleteLocationModel: null,
        autocompleteLocationModel2: null,
        autocompleteLocationModel3: null,
        locationSearchText: null,
        locationSearchText2: null,
        locationSearchText3: null,
        locationEntries: [],
        selectedCities: [],

        search_location: null,
        search_location3: null,

        fetchingLeads1: false,
        add_search_error1: "",

        fetchingLeads2: false,
        add_search_error2: "",

        fetchingLeads3: false,
        add_search_error3: "",
  
        new_searches: null,
        recent_searches: null,

        searchingZipCodes: false,
        zip_codes: [],

        search_type: "local",
        ip_count:0
      }
    },
    computed: {
      ...mapState({
        searches: state => state.searches.searches,
        fetchingSearches: state => state.searches.fetchingSearches,
      }),
      locationFoundItems () {
        return this.locationEntries
      }
    },
    methods: {
      formatDate: function(date) {
        return moment(String(date)).fromNow()
      },

      showLimitReached() {
        let noAccessHtml = `<div id="no-access-html" style="background: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom:0; color: #FFFFFF; text-align: center; z-index: 999;" onclick="document.getElementById('no-access-html').style.display = 'none';">
            <div style="    position: fixed; top: 50%; margin-top: -150px; left: 50%; margin-left: -280px;">
                <h1 style="color: #FFFFFF; font-size: 30px; font-weight: bold; padding-bottom: 10px;">Search Limit Reached</h1>

                <p style="font-weight: bold; font-size: 13px; line-height: 22px;">
                    You have reached your limit. Upgrade your account to get unlimited searches.</p>

                <br />

                <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" style="width: 140px; margin: auto; background-color: #3A9BDB; border-radius: 5px; font-size: 14px; padding: 8px; font-weight: bold; cursor: pointer;" onclick="window.location = '/pricing';">SELECT PLAN</div>
            </div>
        </div>`;

        if (this.$vuetify.breakpoint.xs) {
            noAccessHtml = `<div id="no-access-html" style="background: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom:0; color: #FFFFFF; text-align: center; z-index: 999;" onclick="document.getElementById('no-access-html').style.display = 'none';">
              <div style="    position: fixed; top: 50%; margin-top: -150px; left: 50%; margin-left: -129px;">
                      <h1 style="color: #FFFFFF; font-size: 24px; font-weight: bold; padding-bottom: 10px;">Search Limit Reached</h1>

                      <p style="font-weight: bold; font-size: 13px; line-height: 22px;">
                          You have reached your limit. <br />Upgrade your account to get<br /> unlimited searches.</p>

                      <br />

                      <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" style="width: 140px; margin: auto; background-color: #3A9BDB; border-radius: 5px; font-size: 14px; padding: 8px; font-weight: bold; cursor: pointer;" onclick="window.location = '/pricing';">SELECT PLAN</div>
                  </div>
              </div>`;
        }

        parent.postMessage({
            event_id: 'postHtml',
            data: {
                newHtml: noAccessHtml
            }
        },"*");  //  `*` on any domain
      },
      getCookie: function(name) {
          let value = `; ${document.cookie}`;
          let parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return null;
      },
      setCookie: function(name, value, days) {
          let date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); 
          document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
      },
      fetchLeads1: async function() {
        if (this.new_searches.length + this.recent_searches.length >= 3) {
            // this.showLimitReached();
            // return;
        }

        if (this.selectedCities.length > 3) {
            this.add_search_error1 = "You can only select up to 3 cities.";
            return;
        }

        if (this.ip_count >= 3) {
            this.showLimitReached();
            return;
        }
        this.add_search_error1 = null
  
        if (!this.bulk_1_keyword) {
          this.add_search_error1 = "Please enter keyword.";
          return;
        }
        if (this.bulk_1_keyword.split(",").length  > 3) {
            this.add_search_error1 = "You can only select up to 3 keywords.";
            return;
        }
        if (this.selectedCities.length == 0) {
          this.add_search_error1 = "Please add at least one city.";
          return;
        }
        
        let searchCount = parseInt(this.getCookie('searchCount')) || 0;

        if (searchCount >= 3) {
            this.add_search_error1 = "Search limit reached (3 searches).";
            this.showLimitReached();
            return;
        }
        this.fetchingLeads1 = true;
  
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
          search_keyword: this.bulk_1_keyword,
          cities: this.selectedCities,
          search_type: this.search_type,
          multiple: 1
        } , {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          },
        })
        searchCount++;
        this.setCookie('searchCount', searchCount, 7);

        window.top.location = process.env.VUE_APP_PUBLIC_WIDGETS_URL + '/my-searches';
      },

      fetchLeads2: async function() {
        if (this.new_searches.length + this.recent_searches.length >= 25) {
            // this.showLimitReached();
            // return;
        }
        if (this.ip_count >= 3) {
            this.showLimitReached();
            return;
        }
        this.add_search_error2 = null
        console.log(this.bulk_2_keywords)
        console.log(this.bulk_2_keywords.split(",").length)
        if (this.bulk_2_keywords.split(",").length  > 3) {
            this.add_search_error2 = "You can only select up to 3 keywords.";
            return;
        }
        
        if (!this.search_location) {
            this.add_search_error2 = "Please select location.";
            return;
        }
  
        if (!this.bulk_2_keywords) {
          this.add_search_error2 = "Please enter keywords.";
          return;
        }
          
        let searchCount = parseInt(this.getCookie('searchCount')) || 0;

        if (searchCount >= 3) {
            this.add_search_error2 = "Search limit reached (3 searches).";
            this.showLimitReached();
            return;
        }
        this.fetchingLeads2 = true;
  
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
          search_keyword: this.bulk_2_keywords,
          search_location: this.search_location,
          search_type: this.search_type
        } , {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          },
        })
        searchCount++;
        this.setCookie('searchCount', searchCount, 7);
        window.top.location = process.env.VUE_APP_PUBLIC_WIDGETS_URL + '/my-searches';
      },
  
      fetchLeads3: async function() {
        if (this.new_searches.length + this.recent_searches.length >= 25) {
            // this.showLimitReached();
            // return;
        }
        if (this.ip_count >= 3) {
            this.showLimitReached();
            return;
        }
        this.add_search_error3 = null
  
        if (!this.bulk_3_keyword) {
          this.add_search_error3 = "Please enter keyword.";
          return;
        }
        if (this.bulk_3_keyword.split(",").length  > 3) {
            this.add_search_error3 = "You can only select up to 3 keywords.";
            return;
        }
        if (!this.search_location3) {
          this.add_search_error3 = "Please enter location.";
          return;
        }
          
        let searchCount = parseInt(this.getCookie('searchCount')) || 0;

        if (searchCount >= 3) {
            this.add_search_error3 = "Search limit reached (3 searches).";
            this.showLimitReached();
            return;
        }
        this.fetchingLeads3 = true;
  
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
          search_keyword: this.bulk_3_keyword,
          search_location: this.search_location3,
          search_type: "in_depth"
        } , {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          },
        })
        searchCount++;
        this.setCookie('searchCount', searchCount, 7);
        window.top.location = process.env.VUE_APP_PUBLIC_WIDGETS_URL + '/my-searches';
      },
      getAddressObject(address_components) {
  
        var ShouldBeComponent = {
          street_number: ["street_number"],
          zip: ["postal_code"],
          address: ["street_address", "route"],
          state: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5"
          ],
          city: [
            "locality",
            "colloquial_area",
            "political",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
          ],
          country: ["country"]
        };
  
        var address = {
          street_number: "",
          zip: "",
          address: "",
          state: "",
          city: "",
          country: ""
        };
        address_components.forEach(component => {
          for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
              if (shouldBe === "country") {
                address[shouldBe] = component.short_name;
              } else {
                address[shouldBe] = component.long_name;
              }
            }
          }
        });
        return address;
      },
      filterPlaces (item, queryText, itemText) {
        return true
      },

      addCity() {
        let that = this
  
        $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
          that.company_name = that.autocompleteLocationModel.value.split(",")[0];
  
          let address = that.getAddressObject(response.results[0].address_components);
          let search_location = {};
          search_location.street_number = address.street_number;
          search_location.address = address.address;
          search_location.city = address.city;
          search_location.state = address.state;
          search_location.zip = address.zip;
          search_location.country = address.country;
  
          search_location.lat = response.results[0].geometry.location.lat;
          search_location.lng = response.results[0].geometry.location.lng;
          search_location.place_id = response.results[0].place_id;
  
          that.selectedCities.push(search_location);

          that.autocompleteLocationModel = null;
        });
      },

      removeCity(index) {
        let newCities = [];

        for (var i in this.selectedCities) {
            if (i != index) {
                newCities.push(this.selectedCities[i]);
            }
        }

        this.selectedCities = newCities;
      },

      selectPlace() {
        let that = this
  
        $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel2.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
          that.company_name = that.autocompleteLocationModel2.value.split(",")[0];
  
          let address = that.getAddressObject(response.results[0].address_components);
          let search_location = {};
          search_location.street_number = address.street_number;
          search_location.address = address.address;
          search_location.city = address.city;
          search_location.state = address.state;
          search_location.zip = address.zip;
          search_location.country = address.country;
  
          search_location.lat = response.results[0].geometry.location.lat;
          search_location.lng = response.results[0].geometry.location.lng;
          search_location.place_id = response.results[0].place_id;
  
          that.search_location = search_location;
        });
      },

      selectPlace3() {
        let that = this
  
        $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel3.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
          that.company_name = that.autocompleteLocationModel3.value.split(",")[0];
  
          let address = that.getAddressObject(response.results[0].address_components);
          let search_location3 = {};
          search_location3.street_number = address.street_number;
          search_location3.address = address.address;
          search_location3.city = address.city;
          search_location3.state = address.state;
          search_location3.zip = address.zip;
          search_location3.country = address.country;
  
          search_location3.lat = response.results[0].geometry.location.lat;
          search_location3.lng = response.results[0].geometry.location.lng;
          search_location3.place_id = response.results[0].place_id;
  
          that.search_location3 = search_location3;

          that.searchZipCodes(search_location3.city, search_location3.state);
        });
      },

      async searchZipCodes(city, state) {
        this.searchingZipCodes = true;
        this.zip_codes = [];

        let url = `${process.env.VUE_APP_API_ENDPOINT}/searches/get-zip-codes`;
  
        let response = await axios.get(url + "?city=" + city + "&state=" + state, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          }
        })
  
        this.searchingZipCodes = false;
        this.zip_codes = response.data.zip_codes;
      },

      async getSearches() {
        let url = `${process.env.VUE_APP_API_ENDPOINT}/dashboard-searches`;
  
        let response = await axios.get(url, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          }
        })
  
        this.new_searches = response.data.new_searches;
        this.recent_searches = response.data.recent_searches;
        this.ip_count = response.data.ip_count;
      },
    },
    created() {
        let self = this;
        self.getSearches();
    },
    watch: {
      locationSearchText (newVal) {
        var that = this;
  
        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return
  
        // Call the method from the previous section here
        GetSuggestions(newVal)
          .then(function (res) {
            that.locationEntries = res;
          })
          .catch(function () {
            that.business = false;
            that.step = 1;
          })
      },

      locationSearchText2 (newVal) {
        var that = this;
  
        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return
  
        // Call the method from the previous section here
        GetSuggestions(newVal)
          .then(function (res) {
            that.locationEntries = res;
          })
          .catch(function () {
            that.business = false;
            that.step = 1;
          })
      },

        locationSearchText3 (newVal) {
        var that = this;

        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return

        // Call the method from the previous section here
        GetSuggestions(newVal)
            .then(function (res) {
            that.locationEntries = res;
            })
            .catch(function () {
            that.business = false;
            that.step = 1;
            })
        }
    }
  }
  </script>